import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  alpha,
  colors,
} from "@mui/material";
import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from "react";
import { Colors } from "../../../Constant/Color";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import BasicSelect from "../../../Components/Dropdown";
import { HexColorPicker } from "react-colorful";
import { useDropzone } from "react-dropzone";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CustomButton from "../../../Components/Button";
import axios from "axios";
import { Base_Uri, Image_Uri } from "../../../Constant/BaseUri";
import ProductAddModal from "../../../Components/fileProductaddModal";
import { RingLoader } from "react-spinners";
import CustomModal from "../../../Components/modal";
import { useDispatch, useSelector } from "react-redux";
import {
  updateColors,
  updateProductDepartment,
  updateProductMake,
  updateProducts,
  updateSuppliers,
} from "../../../Redux/LoginReduces";
import { Excel_File_Base64 } from "../../../Constant/exceltempbase64";
import DepartmentModal from "../../../Components/departmentModal";
import MakeModal from "../../../Components/MakeModal";
import {
  Input,
  List,
  message,
  Modal,
  Select,
  Switch,
  Table,
  Upload,
} from "antd";
import { UploadOutlined } from "@mui/icons-material";
import ProductSearch from "./ProductSearch";
import DatePickers from "../../../Components/DatePicker";

export default function AddNewStock() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  let routeData = location?.state;

  const departments = useSelector(
    (state) => state.loginReducer.productDepartments
  );

  const make = useSelector((state) => state?.loginReducer?.make);

  const product = useSelector((state) => state?.loginReducer?.products);

  const suppliers = useSelector((state) => state.loginReducer.suppliers);

  const colors = useSelector((state) => state.loginReducer?.colors);

  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [reportVisible, setReportVisible] = useState(false);
  const [selectProductFromSearch, setSelectProductFromSearch] = useState({});
  const requiredFields = [
    "ProductName",
    "supplier_name",
    "department",
    "category",
    "Sub_Category",
    "make",
    "model",
    "barCode",
    "sku",
  ];

  const handleUpload = async (file) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const skuList = jsonData.map((row) => row.sku);
      const barCodeList = jsonData.map((row) => String(row.barCode));
      const supplierNames = jsonData.map((item) => item.supplier_name);
      const categories = jsonData.map((row) => row.category);
      const subCategories = jsonData.map((row) => row.Sub_Category);

      // Find duplicates in the uploaded file
      const fileDuplicateSku = skuList.filter(
        (sku, idx) => sku && skuList.indexOf(sku) !== idx
      );
      const fileDuplicateBarCode = barCodeList.filter(
        (barCode, idx) => barCode && barCodeList.indexOf(barCode) !== idx
      );

      try {
        const categoryResponse = await axios.post(
          `${Base_Uri}validate-categories`,
          {
            categories: categories.filter(Boolean),
          }
        );

        // Validate subcategories
        const subCategoryResponse = await axios.post(
          `${Base_Uri}validate-subcategories`,
          {
            subCategories: subCategories.filter(Boolean),
          }
        );

        // Validate duplicates with the database
        const response = await axios.post(`${Base_Uri}validate-duplicates`, {
          skus: skuList.filter(Boolean),
          barCodes: barCodeList.filter(Boolean),
        });

        const {
          duplicateSku: dbDuplicateSku,
          duplicateBarCode: dbDuplicateBarCode,
        } = response.data;
        const invalidCategories = categoryResponse.data.existingCategory || [];
        const invalidSubCategories =
          subCategoryResponse.data.existingSubCategory || [];
        // Check supplier names with API
        const supplierCheckResponse = await axios.post(
          `${Base_Uri}validate-suppliers`,
          {
            supplierNames: supplierNames.filter(Boolean),
          }
        );
        const { existingSuppliers: invalidSuppliers } =
          supplierCheckResponse.data;
        console.log(invalidSuppliers, "invalidSuppliers");
        // Process data with both file and database validation
        const processedData = jsonData.map((row, index) => ({
          ...row,
          key: index + 1,
          missingFields: requiredFields.filter((field) => !row[field]),
          isFileDuplicateSku: row.sku && fileDuplicateSku.includes(row.sku),
          isFileDuplicateBarCode:
            row.barCode && fileDuplicateBarCode.includes(String(row.barCode)),
          isDbDuplicateSku: row.sku && dbDuplicateSku.includes(row.sku),
          isDbDuplicateBarCode:
            row.barCode && dbDuplicateBarCode.includes(String(row.barCode)),
          isInvalidSupplier: !(
            row.supplier_name && invalidSuppliers.includes(row.supplier_name)
          ),
          fileDuplicateLinesSku: [],
          fileDuplicateLinesBarCode: [],
          isInvalidCategory: !(
            row.category && invalidCategories.includes(row.category)
          ),
          isInvalidSubCategory: !(
            row.Sub_Category && invalidSubCategories.includes(row.Sub_Category)
          ),
        }));

        console.log(processedData, "processData");

        // Map duplicate lines for file duplicates
        processedData.forEach((row, index) => {
          if (row.isFileDuplicateSku) {
            row.fileDuplicateLinesSku = skuList.reduce(
              (lines, sku, idx) =>
                sku === row.sku ? [...lines, idx + 2] : lines,
              []
            );
          }
          if (row.isFileDuplicateBarCode) {
            row.fileDuplicateLinesBarCode = barCodeList.reduce(
              (lines, barCode, idx) =>
                barCode === String(row.barCode) ? [...lines, idx + 2] : lines,
              []
            );
          }
        });

        setData(processedData);
        setVisible(true);
      } catch (error) {
        console.log(error);
        message.error(
          "Error validating duplicates or suppliers. Please try again."
        );
      }
    };
    reader.readAsBinaryString(file);
    return false;
  };
const [selectedTypeQun, setSelectedTypeQun] = useState("one-to-one");
  const columns = [
    ...requiredFields.map((field) => ({
      title: field,
      dataIndex: field,
      key: field,
    })),
    {
      title: "Issues",
      key: "issues",
      render: (_, record) => {
        const issues = [];
        if (record.missingFields.length > 0)
          issues.push(`Missing fields: ${record.missingFields.join(", ")}`);
        if (record.isFileDuplicateSku)
          issues.push(
            `Duplicate SKU in file (Lines: ${record.fileDuplicateLinesSku.join(
              ", "
            )})`
          );
        if (record.isFileDuplicateBarCode)
          issues.push(
            `Duplicate BarCode in file (Lines: ${record.fileDuplicateLinesBarCode.join(
              ", "
            )})`
          );
        if (record.isDbDuplicateSku) issues.push("Duplicate SKU in database");
        if (record.isDbDuplicateBarCode)
          issues.push("Duplicate BarCode in database");
        if (record.isInvalidSupplier) issues.push("Invalid Supplier Name");
        if (record.isInvalidCategory)
          issues.push("Invalid category in database");
        if (record.isInvalidSubCategory)
          issues.push("Invalid sub-category in database");

        console.log(issues, "issues");
        return issues.join("; ");
      },
    },
  ];

  const getRowClassName = (record) => {
    if (
      record.isFileDuplicateSku ||
      record.isFileDuplicateBarCode ||
      record.isDbDuplicateSku ||
      record.isDbDuplicateBarCode
    ) {
      return "duplicate-row";
    }
    if (record.missingFields.length > 0) return "error-row";
    return "";
  };

  const downloadReport = () => {
    const rowsWithIssues = data.filter(
      (row) =>
        row.missingFields.length > 0 ||
        row.isFileDuplicateSku ||
        row.isFileDuplicateBarCode ||
        row.isDbDuplicateSku ||
        row.isDbDuplicateBarCode ||
        row.isInvalidSupplier ||
        row.isInvalidCategory ||
        row.isInvalidSubCategory ||
        !row.supplier_name // Check for missing supplier_name specifically
    );

    console.log(rowsWithIssues, "rowsWithIssues");
    console.log(data, "rowsWithIssues;data");

    if (rowsWithIssues.length === 0) {
      message.info("No issues to report.");
      return;
    }

    const reportContent = rowsWithIssues
      .map((item) => {
        const issues = [];
        if (item.missingFields.length > 0)
          issues.push(`Missing fields: ${item.missingFields.join(", ")}`);
        if (!item.supplier_name) issues.push("Missing supplier name");
        if (item.isFileDuplicateSku)
          issues.push(
            `Duplicate SKU in file (Lines: ${item.fileDuplicateLinesSku.join(
              ", "
            )})`
          );
        if (item.isFileDuplicateBarCode)
          issues.push(
            `Duplicate BarCode in file (Lines: ${item.fileDuplicateLinesBarCode.join(
              ", "
            )})`
          );
        if (item.isDbDuplicateSku) issues.push("Duplicate SKU in database");
        if (item.isDbDuplicateBarCode)
          issues.push("Duplicate BarCode in database");
        if (item.isInvalidSupplier) issues.push("Invalid Supplier Name");
        if (item.isInvalidCategory) issues.push("Invalid category in database");
        if (item.isInvalidSubCategory)
          issues.push("Invalid sub-category in database");
        console.log(issues, "issues");
        return `Row ${item.key + 1}: ${issues.join("; ")}`;
      })
      .join("\n");

    const blob = new Blob([reportContent], {
      type: "text/plain;charset=utf-8",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "ValidationReport.txt";
    link.click();
  };

  const fileInputRef = useRef(null);
  const [excelData, setExcelData] = useState(null);
  const [productAddModalVisible, setProductAddModalVisible] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [warrantyDuration, setWarrantyDuration] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [departmentLoading, setDepartmentLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [subcategoryLoading, setSubcategoryLoading] = useState(false);
  const [departmentModalVisible, setDepartmentModalVisible] = useState(false);
  const [categoryModalVisible, setCategoryModalVisible] = useState(false);
  const [subCategoryModalVisible, setSubCategoryModalVisible] = useState(false);
  const [departmentName, setDepartmentName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [subcategoryName, setSubcategoryName] = useState("");
  const [colorName, setColorName] = useState(false);
  const [colorLoading, setColorLoading] = useState(false);

  const [selectedSupplier, setSelectedSupplier] = useState("");

  const [editorState, setEditorState] = useState({
    bold: false,
    italic: false,
    underline: false,
    alignment: "left",
    marginTop: "10px",
  });
  const [complementoryProduct, setComplementoryProduct] = useState(false);
  const [deleteImage, setDeleteImage] = useState({
    image: false,
    image1: false,
    image2: false,
  });

  const initialDiscountCategory = [
    {
      id: 1,
      category: "A",
      discount: 0,
      name: "A Category",
    },
    {
      id: 2,
      category: "B",
      discount: 0,
      name: "B Category",
    },
  ];

  const [discountCategory, setDiscountCategory] = useState(
    initialDiscountCategory
  );

  const [selectedCategory, setSelectedCategory] = useState("select");
  const [selectedDepartment, setSelectedDepartment] = useState("select");
  const [categoryPer, setCategoryPer] = useState({
    a: "15",
    b: "15",
    c: "15",
    d:"15"
  });
  const [loading, setLoading] = useState(false);
  const [supplierDetails, setSupplierDetails] = useState({
    supplierName: "",
    shopDetails: "",
    mobileNumber: "",
  });
  const [productLoading, setProductLoading] = useState(false);
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [productDepartment, setProductDepartment] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("select");
  const [selectedMake, setSelectedMake] = useState("select");
  const [selectedModel, setSelectedModel] = useState("select");
  const [choosenColor, setChoosenColor] = useState("");
  const [openMakeModalVisible, setOpenMakeModalVisible] = useState(false);
  const [openModelModalVisible, setOpenModelModalVisible] = useState(false);
  const [color, setColor] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [isWarranty, setIsWarraty] = useState(null);
  const [image, setImage] = useState(null);
  const [barcodeData, setBarcodeData] = useState(""); // Initial barcode data
  const [skuData, setSkuData] = useState(""); // Initial barcode data
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [discardModal, setDiscardModal] = useState(false);

  const [openColorModal, setOpenColorModal] = useState(false);

  const [addNewSupplier, setAddNewSupplier] = useState(false);

  const [makeName, setMakeName] = useState("");
  const [modelName, setModelName] = useState("");
  const [in_wordpress, setIn_wordpress] = useState(false);
  const [selectPriceStatus, setSelectPriceStatus] = useState("wp");

  useEffect(() => {
    console.log(image, "image");
  }, [image]);

  const initialData = {
    ProductName: "",
    productDescription: "",
    // printProductName: "",
    // printProductDescription: "",
    // make: "",
    cost_price: "",
    diamond: "",
    trade_price: "",
    warehouse_price: "",
    compatibility: "",
    retail_price: "",
    // model: "",
    qty: "",
    remind: "",
    IMEI: "",
  };

  const [productData, setProductData] = useState(initialData);

  useEffect(() => {
    if (routeData && Object.keys(routeData).length > 0) {
      console.log(routeData);
      setSelectedCategory(routeData?.category?.trim());
      setSelectedDepartment(routeData?.department);
      setSelectedSubCategory(routeData?.sub_category?.trim());
      setSelectedMake(routeData?.make);
      setSelectedModel(routeData?.model?.trim());
      setChoosenColor(routeData?.product_color);
      setBarcodeData(routeData?.barcode);
      setSkuData(routeData?.sku);
      setSelectedTypeQun(routeData?.qtyType)



      setImage(routeData?.image1_url);
      setImage1(routeData?.image2_url);
      setImage2(routeData?.image3_url);

      let supplierSelect =
        allSuppliers &&
        allSuppliers?.length > 0 &&
        allSuppliers?.filter((e, i) => e._id == routeData?.supplier_id);
      setSelectedSupplier(supplierSelect?.[0]);

      setProductData({
        ProductName: routeData?.productName,
        productDescription: routeData?.product_description,
        cost_price: routeData.qtyType=="unit-boxes"?(Number(routeData?.cost_price)*Number(routeData?.boxes)).toFixed(2):Number(routeData?.cost_price).toFixed(2),
        // diamond: Number(routeData?.diamond),
        diamond: routeData.qtyType=="unit-boxes"?(Number(routeData?.diamond)*Number(routeData?.boxes)).toFixed(2):Number(routeData?.diamond).toFixed(2),
        retail_price: routeData.qtyType=="unit-boxes"?(Number(routeData?.retail_price)*Number(routeData?.boxes)).toFixed(2):Number(routeData?.retail_price).toFixed(2),
        trade_price: routeData.qtyType=="unit-boxes"?(Number(routeData?.trade_price)*Number(routeData?.boxes)).toFixed(2):Number(routeData?.trade_price).toFixed(2),
        warehouse_price: routeData.qtyType=="unit-boxes"?(Number(routeData?.warehouse_price)*Number(routeData?.boxes)).toFixed(2):Number(routeData?.warehouse_price).toFixed(2),
        compatibility: routeData?.compatibility,
        IMEI: routeData?.IMEI,
        qty: routeData.qtyType=="unit-boxes"? Number(routeData?.qty)/Number(routeData?.boxes):Number(routeData?.qty),
        remind: Number(routeData?.reminder_qty),
        expiry: routeData?.expiry,
        boxes:routeData?.boxes,
        qtyType:routeData.qtyType
      });
      setIn_wordpress(routeData.in_wordpress);
    }
  }, [routeData?.barcode, allSuppliers?.length, productDepartment]);

  useEffect(() => {
    if (
      selectProductFromSearch &&
      Object.keys(selectProductFromSearch).length != 0
    ) {
      console.log(selectProductFromSearch);
      setSelectedCategory(selectProductFromSearch?.category?.trim());
      setSelectedDepartment(selectProductFromSearch?.department);
      setSelectedSubCategory(selectProductFromSearch?.sub_category?.trim());
      setSelectedMake(selectProductFromSearch?.make);
      setSelectedModel(selectProductFromSearch?.model?.trim());
      setChoosenColor(selectProductFromSearch?.product_color);
      // setBarcodeData(selectProductFromSearch?.barcode);
      // setSkuData(selectProductFromSearch?.sku);

      setImage(selectProductFromSearch?.image1_url);
      setImage1(selectProductFromSearch?.image2_url);
      setImage2(selectProductFromSearch?.image3_url);

      let supplierSelect =
        allSuppliers &&
        allSuppliers?.length > 0 &&
        allSuppliers?.filter(
          (e, i) => e._id == selectProductFromSearch?.supplier_id
        );
      setSelectedSupplier(supplierSelect?.[0]);

      setProductData({
        ProductName: selectProductFromSearch?.productName,
        productDescription: selectProductFromSearch?.product_description,
        cost_price: selectProductFromSearch.qtyType=="unit-boxes"?(Number(selectProductFromSearch?.cost_price)*Number(selectProductFromSearch?.boxes)).toFixed(2):Number(selectProductFromSearch?.cost_price).toFixed(2),
        // diamond: Number(selectProductFromSearch?.diamond),
        diamond: selectProductFromSearch.qtyType=="unit-boxes"?(Number(selectProductFromSearch?.diamond)*Number(selectProductFromSearch?.boxes)).toFixed(2):Number(selectProductFromSearch?.diamond).toFixed(2),
        retail_price: selectProductFromSearch.qtyType=="unit-boxes"?(Number(selectProductFromSearch?.retail_price)*Number(selectProductFromSearch?.boxes)).toFixed(2):Number(selectProductFromSearch?.retail_price).toFixed(2),
        trade_price: selectProductFromSearch.qtyType=="unit-boxes"?(Number(selectProductFromSearch?.trade_price)*Number(selectProductFromSearch?.boxes)).toFixed(2):Number(selectProductFromSearch?.trade_price).toFixed(2),
        warehouse_price: selectProductFromSearch.qtyType=="unit-boxes"?(Number(selectProductFromSearch?.warehouse_price)*Number(selectProductFromSearch?.boxes)).toFixed(2):Number(selectProductFromSearch?.warehouse_price).toFixed(2),
        compatibility: selectProductFromSearch?.compatibility,
        IMEI: selectProductFromSearch?.IMEI,
        qty:selectProductFromSearch.qtyType=="unit-boxes"? Number(selectProductFromSearch?.qty)/Number(selectProductFromSearch?.boxes):Number(selectProductFromSearch?.qty),
        remind: Number(selectProductFromSearch?.reminder_qty),
        expiry:selectProductFromSearch?.expiry,
        boxes:selectProductFromSearch?.boxes,
        qtyType:selectProductFromSearch.qtyType
      });

      setIn_wordpress(selectProductFromSearch.in_wordpress); // Call callback if passed in `state`
      setProductData(selectProductFromSearch);
      setSelectedTypeQun(selectProductFromSearch.qtyType)
    }
  }, [selectProductFromSearch]);

  const vatRate = useSelector((state) => state.loginReducer.vat)

  const getProducts = async () => {
    // setLoading(true)
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      axios
        .get(`${Base_Uri}getProducts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let myData = res.data;

          let { data } = myData;

          if (data && data.length > 0) {
            let allProducts = [];

            for (var i = 0; i < data.length; i++) {
              let product = data[i];

              product.id = i + 1;
              product["productName"] = product?.product_name;

              if (product.status == "active") {
                product.status = "Active";
              }

              allProducts.push(product);
            }

            dispatch(updateProducts(allProducts));
          }
        })
        .catch((error) => {
          console.log(error, "error");
          // setLoading(false)
        });
    }
  };

  const getDepartments = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      axios
        .get(`${Base_Uri}getProductDepartment`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (data.status) {
            dispatch(updateProductDepartment(data.data));
            setProductDepartment(data?.data);
          }
        });
    }
  };

  const getMake = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      axios
        .get(`${Base_Uri}getProductMake`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (data.status) {
            dispatch(updateProductMake(data.data));
            // setProductDepartment(data?.data);
          }
        });
    }
  };

  const getAllSuppliers = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getSuppliers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (data.status) {
          dispatch(updateSuppliers(data.data));
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };
  const getColors = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getColors`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (data.status) {
          dispatch(updateColors(data.data));
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  useEffect(() => {
    getDepartments();
    getMake();
  }, [departments.length, make.length]);

  useEffect(() => {
    getAllSuppliers();
    getColors();
  }, []);

  useEffect(() => {
    if (productData?.cost_price && selectedCategory) {
      console.log(productData?.cost_price, "productData?.cost_price");

      let selectedDep =
        productDepartment &&
        productDepartment.length > 0 &&
        productDepartment?.filter(
          (e) => e?.departmentName == selectedDepartment
        );
      let selectedCat =
        selectedDep &&
        selectedDep[0]?.categories?.length > 0 &&
        selectedDep[0]?.categories?.filter(
          (e) => e?.categoryName.trim() == selectedCategory
        );
      selectedCat = selectedCat[0];

      setProductData({
        ...productData,
        trade_price: Math.round(
          Number(productData?.cost_price) +
            (Number(productData?.cost_price) *
              Number(selectedCat?.categoryPer?.a)) /
              100
        ),
        diamond: Math.round(
          Number(productData?.cost_price) +
            (Number(productData?.cost_price) *
              Number(selectedCat?.categoryPer?.d)) /
              100
        ),
        warehouse_price: Math.round(
          Number(productData?.cost_price) +
            (Number(productData?.cost_price) *
              Number(selectedCat?.categoryPer?.b)) /
              100
        ),
        retail_price: Math.round(
          Number(productData?.cost_price) +
            (Number(productData?.cost_price) *
              Number(selectedCat?.categoryPer?.c)) /
              100
        ),
        
      });
      console.log(selectedCat);
      console.log(
        {
          trade_price: Math.round(
            Number(productData?.cost_price) +
              (Number(productData?.cost_price) *
                Number(selectedCat?.categoryPer?.a)) /
                100
          ),
          warehouse_price: Math.round(
            Number(productData?.cost_price) +
              (Number(productData?.cost_price) *
                Number(selectedCat?.categoryPer?.b)) /
                100
          ),
          retail_price: Math.round(
            Number(productData?.cost_price) +
              (Number(productData?.cost_price) *
                Number(selectedCat?.categoryPer?.c)) /
                100
          ),
        },
        "ddkdkdk"
      );
    }
  }, [productData?.cost_price,routeData?.barCode, selectedCategory]);

  React.useEffect(() => {
    setAllSuppliers(suppliers);
  }, [suppliers]);

  const supplierName =
    suppliers &&
    suppliers.length > 0 &&
    suppliers.map((e, i) => {
      return e.supplierName;
    });

  // const downloadTemplate = () => {
  //   let base64 = Excel_File_Base64;
  //   let sliceSize = 1024;
  //   let byteCharacter = atob(base64);
  //   let bytesLenght = byteCharacter.length;
  //   let slicesCount = Math.ceil(bytesLenght / sliceSize);
  //   let byteArrays = new Array(slicesCount);

  //   for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
  //     let begin = sliceIndex * sliceSize;
  //     let end = Math.min(begin + sliceSize, bytesLenght);
  //     let bytes = new Array(end - begin);

  //     for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
  //       bytes[i] = byteCharacter[offset].charCodeAt(0);
  //     }

  //     byteArrays[sliceIndex] = new Uint8Array(bytes);
  //   }

  //   let blob = new Blob(byteArrays, { type: "application/vnd.ms-excel" });

  //   saveAs(new Blob([blob], {}), "my-excel.xlsx");
  // };
  const downloadTemplate = (data) => {
    // Create a new workbook and worksheet
    const ws = XLSX.utils.json_to_sheet([{
      ProductName:{},
      productDescription:{},
      colors:{},
      supplier_name:{},
      supplier_address:{},
      supplier_mobile_number:{},
      department:{},
      category:{},
      Sub_Category:{},
      make:{},
      model:{},
      qty:{},
      remind:{},
      cost_price:{},
      diamond:{},
      platinum:{},
      gold:{},
      retail_price:{},
      barCode:{},
      sku:{},
      in_wordpress:{},
  }]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    // Write the Excel file and create a Blob
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Save the file
    saveAs(dataBlob, "Report.xlsx");
  };
  function pad(num, size) {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
  const [barCodeOnce,setBarcodeOnce] = useState(false)
  const [skuOnce,setSkuOnce] = useState(false)
  const generateNewBarcode = async() => {
    // if (product && product?.length > 0) {

    //   let length = product.length

    //   let lastProduct = product[length - 1]

    //   let lastBarcode = lastProduct?.barcode.toString()

    //   let newBarcodeData;
    //   if (lastBarcode !== null) {
    //     // Increment the last barcode serial wise
    //     const lastSerial = parseInt(lastBarcode.slice(-6)); // Extract last 6 digits as serial
    //     const newSerial = lastSerial + 1;
    //     newBarcodeData = lastBarcode.slice(0, -6) + pad(newSerial, 6); // Combine prefix and padded serial
    //   } else {
    //     // If no previous barcode, generate a random one as fallback
    //     newBarcodeData = Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
    //   }

    //   setBarcodeData(newBarcodeData);

    // } else {

    //   setBarcodeData(Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'));
    // }
    // setBarcodeData(
    //   Math.floor(Math.random() * 1000000000)
    //     .toString()
    //     .padStart(9, "0")
    // );
    let data =  sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (!barCodeOnce) {
      await axios.get(`${Base_Uri}getProducts/barcode`,{headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data", // Include other headers as needed
      }}).then((data)=>{
        setBarcodeData(data.data.barcode)
        setBarcodeOnce(true)
      })
    }
  };

  const generateNewSku = async() => {
    let data =  sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;
    if (!skuOnce) {
    await  axios.get(`${Base_Uri}getProducts/sku`,{headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data", // Include other headers as needed
      }}).then((data)=>{
        setSkuData(data.data.sku)
        setSkuOnce(true)
      })
    }
  };

  const onDrop = useCallback(
    async (acceptedFiles) => {
      // Do something with the files

      const file = acceptedFiles[0];

      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        message.info("Invalid file type. Please select a PNG or JPEG image.");
        return;
      }

      const formData = new FormData();
      formData.append("productImages", file);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .post(`${Base_Uri}uploadProductImage`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            return;
          }

          if (data?.data?.filename) {
            if (!image) {
              setImage(data?.data?.filename);
            } else if (!image1) {
              setImage1(data?.data?.filename);
            } else {
              setImage2(data?.data?.filename);
            }
          }
        })
        .catch((error) => {
          console.log(error, "error");
        });
    },
    [image, image1, image2]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const deleteCategory = (ind) => {
    setDiscountCategory(discountCategory.filter((e, i) => i !== ind));
  };

  const closeColorPicker = () => {
    let length = selectedColor.length;

    setSelectedColor([
      ...selectedColor,
      {
        id: length + 1,
        color: color,
      },
    ]);

    setShowColorPicker(false);
  };

  const handleDeleteImage = (ind) => {
    if (ind == 0) {
      setImage("");
      setDeleteImage({
        ...deleteImage,
        image: false,
      });
    } else if (ind == 1) {
      setImage1("");
      setDeleteImage({
        ...deleteImage,
        image1: false,
      });
    } else if (ind == 2) {
      setImage2("");
      setDeleteImage({
        ...deleteImage,
        image2: false,
      });
    }
  };

  const handleExcelFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      readExcel(file);
    }
  };

  const readExcel = (file) => {
    setFileLoading(true);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;

      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
        message.info("Invalid file. Please upload a valid Excel file.");
        setFileLoading(false);
        return;
      }

      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      let arrayOfObjects = convertArrayToObject(jsonData);

      for (var i = 0; i < arrayOfObjects?.length; i++) {
        let data = arrayOfObjects[i];
        console.log(data);
        let {
          ProductName,
          productDescription,
          colors,
          image1,
          image2,
          image3,
          department,
          category,
          Sub_Category,
          make,
          model,
          qty,
          remind,
          supplier_name,
          supplier_address,
          supplier_mobile_number,
          cost_price,
          warehouse_price: gold,
          trade_price: platinum,
          diamond,
          retail_price,
          barCode,
        } = data;

        if (
          !ProductName ||
          !department ||
          !category ||
          !Sub_Category ||
          !make ||
          !model ||
          !barCode
          // !cost_price ||
          // !trade_price ||
          // !retail_price ||
          // !warehouse_price
        ) {
          message.info(
            `Required fields are missing check your file and make nacessary changes ${i}`
          );
          return;
        }

        // if (warranty && !warranty_duration) {
        //   message.info(
        //     "You must provide warranty duration if there is product warranty"
        //   );
        //   return;
        // }
      }

      setExcelData(arrayOfObjects);
      setProductAddModalVisible(true);
    };

    reader.readAsBinaryString(file);
  };

  const handleButtonClick = () => {
    // Trigger the file input click event
    fileInputRef.current.click();
  };

  const convertArrayToObject = (dataArray) => {
    if (Array.isArray(dataArray)) {
      const headers = dataArray[0];
      const dataObjects = [];

      for (let i = 1; i < dataArray.length; i++) {
        const currentRow = dataArray[i];
        const rowDataObject = {};

        if (currentRow.length > 0) {
          for (let j = 0; j < headers.length; j++) {
            rowDataObject[headers[j]] = currentRow[j];
          }
          dataObjects.push(rowDataObject);
        }
      }
      setFileLoading(false);
      return dataObjects;
    }
  };

  const handleSubmitFile = async () => {
    setSubmitLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .post(`${Base_Uri}addMultipleProducts`, excelData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (data && data.status) {
          message.info("File Submitted Successfully");
          setSubmitLoading(false);
          getProducts();
          setProductAddModalVisible(false);
          setExcelData([]);
        } else {
          message.info(`${res.data.message}`);
          setSubmitLoading(false);
          setProductAddModalVisible(false);
        }
      })
      .catch((error) => {
        setSubmitLoading(false);
      });
  };

  const closeProductModal = () => {
    setProductAddModalVisible(false);
  };

  const handleDiscount = (event, ind) => {
    setDiscountCategory(
      discountCategory &&
        discountCategory?.length > 0 &&
        discountCategory?.map((e, i) => {
          if (i == ind) {
            return {
              ...e,
              discount: event,
            };
          } else {
            return e;
          }
        })
    );
  };

  const handleDiscardClick = () => {
    setDiscardModal(true);
  };

  const handleConfirmClick = () => {
    setProductData(initialData);
    setSelectedCategory("select");
    setSelectedDepartment("select");
    setSelectedColor([]);
    setSelectedSubCategory("select");
    setImage("");
    setImage1("");
    setImage2("");
    setBarcodeData("");
    setSkuData("");
    setIsWarraty(false);
    setDiscountCategory(initialDiscountCategory);
    setDiscardModal(false);
  };

  const handleNextClick = async () => {
    if (selectedDepartment == "select" || !selectedDepartment) {
      message.info("Selected department is missing");
      return;
    }

    if (selectedCategory == "select" || !selectedCategory) {
      message.info("Selected Category is missing");
      return;
    }

    // if (choosenColor == "select" || !choosenColor) {
    //   message.info("Selected Color is missing");
    //   return;
    // }

    // if (selectedMake == "select" || !selectedMake) {
    //   message.info("Make is missing");
    //   return;
    // }

    // if (selectedMake == "select" || !selectedModel) {
    //   message.info("Make is missing");
    //   return;
    // }

    if (!barcodeData) {
      message.info("Barcode is missing");
      return;
    }

    if (!productData?.qty) {
      message.info("Quantity is missing");
      return;
    }

    if (!productData?.cost_price) {
      message.info("Cost Price is missing");
      return;
    }
    // if (!productData?.diamond) {
    //   message.info("Diamond Price is missing");
    //   return;
    // }

    // if (!productData?.trade_price && !routeData) {
    //   message.info("Platinum Price is missing");
    //   return;
    // }

    // if (!productData?.warehouse_price && !routeData) {
    //   message.info("Gold Price is missing");
    //   return;
    // }

    if (!productData?.retail_price && !routeData) {
      message.info("Retail Price is missing");
      return;
    }

    if (!selectedSupplier || Object.keys(selectedSupplier).length == 0) {
      message.info("Kindly select supplier");
      return;
    }
    if (!skuData) {
      message.info("Sku is missing");
      return;
    }

    let selectedDep =
      productDepartment &&
      productDepartment.length > 0 &&
      productDepartment?.filter((e) => e?.departmentName == selectedDepartment);
    let selectedCat =
      selectedDep &&
      selectedDep[0]?.categories?.length > 0 &&
      selectedDep[0]?.categories?.filter(
        (e) => e?.categoryName == selectedCategory
      );
    selectedCat = selectedCat[0];

    let allData = { ...productData };

    if (!allData?.ProductName) {
      if (selectedSubCategory && selectedSubCategory !== "select") {
        allData.ProductName =
          selectedMake +
            " " +
            selectedModel +
            " " +
            selectedCategory +
            " " +
            selectedSubCategory +
            " " +
            choosenColor || "";
      } else {
        allData.ProductName =
          selectedMake +
          " " +
          selectedModel +
          " " +
          selectedCategory +
          " " +
          choosenColor;
      }
    }

    console.log(allData,"jd")

    let data = {
      ...allData,
      department: selectedDepartment,
      Sub_Category: selectedSubCategory,
      category: selectedCategory,
      make: selectedMake,
      model: selectedModel,
      colors: choosenColor,
      categoryPer: selectedCat?.categoryPer,
      barCode: barcodeData,
      supplier_name: selectedSupplier.supplierName,
      supplier_address: selectedSupplier?.shopDetails,
      supplier_mobile_number: selectedSupplier?.mobileNumber,
      supplier_id: selectedSupplier?._id,
      image1: image,
      image2: image1,
      image3: image2,
      status: "Active",
      sku: skuData,
      in_wordpress: in_wordpress,
      pr: selectPriceStatus,
      qtyType:selectedTypeQun,
      cost_price:selectedTypeQun=="unit-boxes"?Number(allData.cost_price)/Number(allData.boxes):Number(allData.cost_price),
      retail_price:selectedTypeQun=="unit-boxes"?allData.retail_price/Number(allData.boxes):allData.retail_price,
      warehouse_price:selectedTypeQun=="unit-boxes"?allData.warehouse_price/Number(allData.boxes):allData.warehouse_price,
      diamond:selectedTypeQun=="unit-boxes"?allData.diamond/Number(allData.boxes):allData.diamond,
      trade_price:selectedTypeQun=="unit-boxes"?allData.trade_price/Number(allData.boxes):allData.trade_price,
      qty:selectedTypeQun=="unit-boxes"?Number(allData.qty)*Number(allData.boxes):Number(allData.qty)
    };
console.log(data,"data")
    setLoading(true);

    let myData = await sessionStorage.getItem("userData");
    myData = JSON.parse(myData);
    let token = myData;

    if (routeData && routeData?.edit) {
      data.trade_price = data?.trade_price
        ? data?.trade_price
        : routeData?.trade_price;
      data.diamond = data?.diamond
        ? data?.diamond
        : routeData?.diamond;
      data.warehouse_price = data?.warehouse_price
        ? data?.warehouse_price
        : routeData?.warehouse_price;
      data.retail_price = data?.retail_price
        ? data?.retail_price
        : routeData?.retail_price;

      axios
        .put(`${Base_Uri}editProducts`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data?.status) {
            message.info(data.message);
            setLoading(false);
            return;
          }

          if (data.status) {
            message.info(data.message);
            setLoading(false);
            getProducts();
            setProductData(initialData);
            setSelectedCategory("select");
            setColor("");
            setBarcodeData("");
            setChoosenColor("");
            setSelectedDepartment("select");
            setSelectedSubCategory("select");
            setSelectedModel("select");
            setSelectedTypeQun("one-to-one");
            setSelectedMake("select");
            setBarcodeData("")
            setSkuData("")
            // setProductData([])
            setBarcodeOnce(false)
            setSkuOnce(false)
            setImage("");
            setImage1("");
            setImage2("");
            setSelectedSupplier("select");
            setAllSuppliers(
              allSuppliers.map((e, i) => {
                return {
                  ...e,
                  selected: false,
                };
              })
            );
            // navigate(location.pathname, { replace: true });
            navigate("/Home");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error, "error");
        });

      return;
    }

    axios
      .post(`${Base_Uri}addProduct`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (!data?.status) {
          message.info(data.message);
          setLoading(false);
          return;
        }

        if (data.status) {
          message.info(data.message);
          setLoading(false);
          getProducts();
          setProductData(initialData);
          setSelectedCategory("select");
          setColor("");
          setBarcodeData("");
          setChoosenColor("");
          setSelectedDepartment("select");
          setSelectedSubCategory("select");
          setSelectedModel("select");
          setSelectedSupplier("select");
          setSelectedMake("select");
          setBarcodeData("")
            setSkuData("")
            setSelectedTypeQun("one-to-one")
            setSkuOnce(false)
            // setProductData([])
            setBarcodeOnce(false)
          setImage("");
          setImage1("");
          setImage2("");
          setAllSuppliers(
            allSuppliers.map((e, i) => {
              return {
                ...e,
                selected: false,
              };
            })
          );
          // navigate("/Home")
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error, "error");
      });

    // navigate("./PriceDetails", { state: data });
  };

  const handleAddDepartment = async () => {
    if (!departmentName) {
      message.info("Kindly add department name");
      return;
    }

    setDepartmentLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      let dataToSend = {
        departmentName: departmentName,
      };

      axios
        .post(`${Base_Uri}addProductDepartment`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setDepartmentLoading(false);
            return;
          }

          message.info(data.message);
          getDepartments();
          setDepartmentModalVisible(false);
          setDepartmentLoading(false);
        })
        .catch((error) => {
          message.info(error?.message);
          setDepartmentLoading(false);
          return;
        });
    }
  };
  const handleAddCategory = async () => {
    if (!selectedDepartment) {
      message.info("Kindly add department");
      return;
    }

    if (!categoryName) {
      message.info("Kindly add category name");
      return;
    }

    setCategoryLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      let dataToSend = {
        departmentName: selectedDepartment,
        categoryName: categoryName,
        categoryPer: categoryPer,
      };

      axios
        .post(`${Base_Uri}addProductCategory`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setCategoryLoading(false);
            return;
          }

          message.info(data.message);
          setCategoryModalVisible(false);
          setCategoryLoading(false);
          getDepartments();
        })
        .catch((error) => {
          message.info(error?.message);
          setCategoryLoading(false);
          return;
        });
    }
  };

  const handleAddSubCategory = async () => {
    if (!selectedDepartment) {
      message.info("Kindly add department");
      return;
    }

    if (!selectedCategory) {
      message.info("Kindly add category name");
      return;
    }

    if (!subcategoryName) {
      message.info("Kindly add subcategory name");
      return;
    }

    setSubcategoryLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      let dataToSend = {
        departmentName: selectedDepartment,
        categoryName: selectedCategory,
        subcategoryName: subcategoryName,
      };

      axios
        .post(`${Base_Uri}addProductSubcategory`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setSubcategoryLoading(false);
            return;
          }

          message.info(data.message);
          setSubCategoryModalVisible(false);
          setSubcategoryLoading(false);
          getDepartments();
        })
        .catch((error) => {
          message.info(error?.message);
          setSubcategoryLoading(false);
          return;
        });
    }
  };

  const handleAddMake = async () => {
    if (!makeName) {
      message.info("Kindly add make name");
      return;
    }

    setDepartmentLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      let dataToSend = {
        make: makeName,
      };

      axios
        .post(`${Base_Uri}addProductMake`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setDepartmentLoading(false);
            return;
          }

          message.info(data.message);
          getMake();
          setOpenMakeModalVisible(false);
          setDepartmentLoading(false);
        })
        .catch((error) => {
          message.info(error?.message);
          setDepartmentLoading(false);
          return;
        });
    }
  };

  const handleAddModel = async () => {
    if (!selectedMake) {
      message.info("Kindly add Make");
      return;
    }

    if (!modelName) {
      message.info("Kindly add model name");
      return;
    }

    setCategoryLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      let dataToSend = {
        make: selectedMake,
        model: modelName,
      };

      axios
        .post(`${Base_Uri}addProductModel`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setCategoryLoading(false);
            return;
          }

          message.info(data.message);
          setOpenModelModalVisible(false);
          setCategoryLoading(false);
          getMake();
        })
        .catch((error) => {
          message.info(error?.message);
          setCategoryLoading(false);
          return;
        });
    }
  };

  const selectSupplier = (supplierName) => {
    let supplierselect = allSuppliers?.filter(
      (e, i) => e.supplierName == supplierName
    );

    supplierselect = supplierselect?.[0];

    setSelectedSupplier(supplierselect);

    setAllSuppliers(
      allSuppliers.map((e, i) => {
        if (e.supplierName == supplierName) {
          return {
            ...e,
            selected: true,
          };
        } else {
          return {
            ...e,
            selected: false,
          };
        }
      })
    );
  };

  let categories = [];
  let subcat = [];
  let model = [];

  if (selectedDepartment) {
    let getDepartment =
      productDepartment &&
      productDepartment.length > 0 &&
      productDepartment.filter((e, i) => {
        return e.departmentName == selectedDepartment;
      });

    if (getDepartment && getDepartment.length > 0) {
      let dept = getDepartment[0];

      categories =
        dept.categories &&
        dept.categories.length > 0 &&
        dept.categories.map((e, i) => {
          return e?.categoryName.trim();
        });
    }
  }

  if (selectedMake) {
    let getModal =
      make &&
      make.length > 0 &&
      make.filter((e, i) => {
        return e.make == selectedMake;
      });

    if (getModal && getModal.length > 0) {
      let dept = getModal[0];

      model =
        dept.model &&
        dept.model.length > 0 &&
        dept.model.map((e, i) => {
          return e?.model.trim();
        });
    }
  }

  if (selectedDepartment && selectedCategory) {
    let getDepartment =
      productDepartment &&
      productDepartment.length > 0 &&
      productDepartment.filter((e, i) => {
        return e.departmentName == selectedDepartment;
      });

    if (getDepartment && getDepartment.length > 0) {
      let dept = getDepartment[0];

      let mySelectedCat =
        dept.categories &&
        dept.categories.length > 0 &&
        dept.categories.filter((e, i) => {
          return e?.categoryName.trim() == selectedCategory;
        });

      let selectedCat = mySelectedCat[0];

      subcat =
        selectedCat?.subcategories && selectedCat?.subcategories.length > 0
          ? selectedCat?.subcategories.map((e, i) => {
              return e.subcategoryName.trim();
            })
          : [];
    }
  }

  const handleAddSupplier = async () => {
    if (!supplierDetails.supplierName) {
      message.info("supplier name is missing");
      return;
    }
    if (!supplierDetails.mobileNumber) {
      message.info("mobile Number is missing");
      return;
    }
    if (!supplierDetails.shopDetails) {
      message.info("Shop details is missing");
      return;
    }

    setLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .post(`${Base_Uri}addSupplier`, supplierDetails, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        setLoading(false);

        if (data.status) {
          message.info(data?.message);
          setLoading(false);
          getAllSuppliers();
          setAddNewSupplier(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleAddColor = async () => {
    if (!colorName) {
      message.info("Enter Color Name");
      return;
    }

    let dataToSend = {
      color: colorName,
    };

    setColorLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .post(`${Base_Uri}addColor`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;
        if (!data?.status) {
          message.info(data.message);
          setColorLoading(false);
          return;
        }

        let newColor = data.data;

        let allColors = [...colors, newColor];
        setColorLoading(false);
        message.info(data.message);
        setOpenColorModal(false);
        dispatch(updateColors(allColors));
      })
      .catch((error) => {
        console.log(error, "error");
        message.info("Internal Server Error");
        setColorLoading(false);
        return;
      });
  };

  return fileLoading || submitLoading ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <RingLoader
        loading={fileLoading || submitLoading}
        size={100}
        color={Colors.black}
      />
      <Typography
        style={{ fontSize: "24px", color: Colors.black, fontFamily: "Poppins" }}
      >
        {fileLoading ? "Checking File..." : "Submiting File..."}
      </Typography>
    </Box>
  ) : (
    <Box style={{ color: "black" }}>
      <Box
        style={{
          width: "100%",
          marginTop: 15,
          padding: "10px 10px 10px 10px",
          backgroundColor: Colors?.white,
          // marginBottom:15
          height: 50,
          borderRadius: 10,
        }}
      >
        <ProductSearch
          products={product}
          setSelectProductFromSearch={setSelectProductFromSearch}
        />
      </Box>
      <Box
        style={{
          width: "100%",
          marginTop: 30,
          padding: "0px 10px 0px 10px",
          backgroundColor: Colors?.white,
        }}
      >
        {productAddModalVisible && (
          <ProductAddModal
            heading="File Uploaded"
            text={"Are you sure you want to add this file product"}
            confirm={handleSubmitFile}
            open={productAddModalVisible}
            closeModal={closeProductModal}
          />
        )}

        {/* {arrayOfObjects && arrayOfObjects?.length > 0 && <CustomButton onClick={handleSubmitFile} text="Submit file" />} */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box style={{ padding: 10 }}>
              {/* Content for the first column */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Product Details
                </Typography>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <Upload
                    beforeUpload={handleUpload}
                    showUploadList={false}
                    accept=".xlsx, .xls"
                  >
                    <Button
                      style={{
                        borderRadius: 20,
                        backgroundColor: Colors.button,
                        color: Colors.white,
                        fontSize: 12,
                        padding: 10,
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                      }}
                      icon={<UploadOutlined />}
                    >
                      Verify File
                    </Button>
                  </Upload>
                  <Button
                    onClick={handleButtonClick}
                    style={{
                      borderRadius: 20,
                      backgroundColor: Colors.button,
                      color: Colors.white,
                      fontSize: 12,
                      padding: 10,
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                    }}
                  >
                    Upload CSV File
                  </Button>
                </div>

                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleExcelFileChange}
                />
              </Box>
              <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    color: Colors.text,
                    fontSize: 14,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Product Name
                </Typography>
                <TextField
                  value={
                    productData?.ProductName
                      ? productData?.ProductName
                      : selectedMake?.trim() ||
                        selectedMake !== "select" ||
                        selectedModel?.trim() ||
                        selectedModel !== "select" ||
                        selectedCategory?.trim() &&
                        selectedCategory !== "select" &&
                        selectedMake?.trim() ||
                        selectedMake !== "select" ||
                        selectedModel?.trim() ||
                        selectedModel !== "select"
                      ? selectedMake?.trim()=="select"?"":selectedMake?.trim() +
                        " " +
                        selectedModel?.trim()=="select"?"":selectedModel?.trim() +
                        " " +
                        selectedCategory?.trim() +
                        " " +
                        (selectedSubCategory !== "select"
                          ? selectedSubCategory?.trim()
                          : "") +
                        " " +
                        (choosenColor?choosenColor !== "select" ? choosenColor?.trim() : "":"")
                      : ""
                  }
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      ProductName: e.target.value,
                    }))
                  }
                  size="small"
                  placeholder="Type Product Name"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />

                <Box
                  style={{
                    padding: "15px 0px 0px 0px",
                    marginTop: 5,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Description
                  </Typography>
                  <Box
                    style={{
                      width: "100%",
                      padding: "0px 0px 0px 0px",
                      borderBottom: 0,
                      marginTop: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        border: `1px solid ${Colors.border}`,
                        justifyContent: { xs: "space-between" },
                        borderBottom: "0px",
                        padding: 1,
                        flexWrap: "wrap",
                        marginTop: 0.5,
                        borderTopRightRadius: "5px",
                        borderTopLeftRadius: "5px",
                      }}
                    >
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            bold: !editorState?.bold,
                          })
                        }
                        style={{
                          backgroundColor: editorState?.bold
                            ? Colors.buttonLight
                            : Colors.white,
                          border: "0px",
                          borderRadius: 5,
                        }}
                      >
                        <img src={require("../../../Images/bold.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            italic: !editorState?.italic,
                          })
                        }
                        style={{
                          backgroundColor: editorState?.italic
                            ? Colors.buttonLight
                            : Colors.white,
                          border: "0px",
                          borderRadius: 5,
                        }}
                      >
                        <img src={require("../../../Images/italic.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            underline: !editorState?.underline,
                          })
                        }
                        style={{
                          backgroundColor: editorState?.underline
                            ? Colors.buttonLight
                            : Colors.white,
                          border: "0px",
                        }}
                      >
                        <img src={require("../../../Images/underline.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            alignment: "left",
                          })
                        }
                        style={{
                          backgroundColor:
                            editorState?.alignment == "left"
                              ? Colors.buttonLight
                              : Colors.white,
                          border: "0px",
                          borderRadius: 5,
                        }}
                      >
                        <img src={require("../../../Images/left.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            alignment: "center",
                          })
                        }
                        style={{
                          backgroundColor:
                            editorState?.alignment == "center"
                              ? Colors.buttonLight
                              : Colors.white,
                          border: "0px",
                        }}
                      >
                        <img src={require("../../../Images/center.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            alignment: "right",
                          })
                        }
                        style={{
                          backgroundColor:
                            editorState?.alignment == "right"
                              ? Colors.buttonLight
                              : Colors.white,
                          border: "0px",
                        }}
                      >
                        <img src={require("../../../Images/right.png")} />
                      </button>
                    </Box>
                    <Box>
                      <textarea
                        value={productData.productDescription}
                        onChange={(e) =>
                          setProductData((prev) => ({
                            ...prev,
                            productDescription: e.target.value,
                          }))
                        }
                        size="small"
                        multiline={true}
                        row={10}
                        placeholder="Type Description..."
                        style={{
                          width: "100%",
                          fontSize: 14,
                          padding: "3px 10px 3px 10px",
                          marginTop: 1,
                          fontFamily: "Poppins",
                          border: `1px solid ${Colors.border}`,
                          height: 100,
                          fontWeight: editorState?.bold ? "bold" : "normal",
                          fontStyle: editorState?.italic ? "italic" : "normal",
                          textDecoration: editorState?.underline
                            ? "underline"
                            : "none",
                          textAlign: editorState?.alignment,
                          borderBottomLeftRadius: "5px",
                          borderBottomRightRadius: "5px",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
              {/* <Button
                onClick={() => setComplementoryProduct(!complementoryProduct)}
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 5,
                  border: `2px dotted ${Colors.button}`,
                  padding: 5,
                  marginTop: 10,
                  backgroundColor: Colors.buttonLight,
                }}
              >
                {complementoryProduct ? (
                  <DeleteIcon fontSize="large" color={Colors.button} />
                ) : (
                  <AddIcon fontSize="large" color={Colors.button} />
                )}
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: Colors.button,
                    fontFamily: "Poppins",
                    fontWeight: "600",
                  }}
                >
                  {complementoryProduct ? "Remove" : "Add"} Complementory
                  Product
                </Typography>
              </Button>
              {complementoryProduct && (
                <Box
                  style={{
                    border: `2px dotted ${Colors.button}`,
                    padding: 15,
                    marginTop: 10,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                      }}
                    >
                      Product Name
                    </Typography>

                    <Button
                      style={{
                        borderRadius: 20,
                        backgroundColor: Colors.button,
                        color: Colors.white,
                        fontSize: 12,
                        padding: 10,
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        marginBottom: 5,
                      }}
                    >
                      Choose Product
                    </Button>
                  </Box>
                  <BasicSelect
                    style={{ marginTop: 0.5 }}
                    value={selectedCategory}
                    status="Select Product Category"
                    id={productCategory}
                    width={"100%"}
                    onChange={(e) => setSelectedCategory(e)}
                  />

                  <Box
                    style={{
                      padding: "15px 0px 0px 0px",
                      marginTop: 5,
                      borderRadius: 5,
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                      }}
                    >
                      Quantity
                    </Typography>
                    <Box
                      style={{
                        width: "100%",
                        padding: "0px 0px 0px 0px",
                        borderBottom: 0,
                        marginTop: 0.5,
                      }}
                    >
                      <TextField
                        // value={data.cityName}
                        // onChange={(e) =>
                        //   setData((prev) => ({ ...prev, cityName: e.target.value }))
                        // }

                        // variant="standard"
                        size="small"
                        placeholder="Add Product Quantity"
                        sx={{
                          width: "100%",
                          fontSize: "10px",
                          padding: 0,
                          marginTop: 0.5,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              )} */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 15,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Department
                </Typography>

                <CustomButton
                  onClick={() => setDepartmentModalVisible(true)}
                  text="Add Department"
                  style={{
                    width: "fit-content",
                    padding: 1,
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                />
              </Box>
              <BasicSelect
                style={{ marginTop: 0.5 }}
                value={selectedDepartment}
                status="Select Deparment"
                id={
                  productDepartment && productDepartment.length > 0
                    ? productDepartment.map((e) => e?.departmentName)
                    : []
                }
                width={"100%"}
                onChange={(e) => setSelectedDepartment(e)}
              />
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 15,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Category
                </Typography>
              </Box>
              <Box
                style={{
                  border: `2px dotted ${Colors.button}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Product Category
                  </Typography>

                  <CustomButton
                    onClick={() => setCategoryModalVisible(true)}
                    text="Add Category"
                    style={{
                      width: "fit-content",
                      padding: 1,
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  />
                </Box>
                <BasicSelect
                  style={{ marginTop: 0.5 }}
                  value={selectedCategory}
                  status="Select Product Category"
                  id={categories}
                  width={"100%"}
                  onChange={(e) => setSelectedCategory(e)}
                />

                <Box
                  style={{
                    padding: "15px 0px 0px 0px",
                    marginTop: 5,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Box
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                      }}
                    >
                      Sub Category
                    </Typography>

                    <CustomButton
                      onClick={() => setSubCategoryModalVisible(true)}
                      text="Add Subcategory"
                      style={{
                        width: "fit-content",
                        padding: 1,
                        borderRadius: "5px",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    />
                  </Box>

                  <BasicSelect
                    style={{ marginTop: 0.5 }}
                    value={selectedSubCategory}
                    status="Select Product Subcategory"
                    id={subcat}
                    width={"100%"}
                    onChange={(e) => setSelectedSubCategory(e)}
                  />
                </Box>
              </Box>
              {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="color")?.is &&<Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 15,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Colors
                </Typography>

                <CustomButton
                  onClick={() => setOpenColorModal(true)}
                  text="Add Color"
                  style={{
                    width: "fit-content",
                    padding: 1,
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                />
              </Box>}
             {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="color")?.is && <BasicSelect
                style={{ marginTop: 0.5 }}
                value={choosenColor}
                status="Select Color"
                id={
                  colors && colors.length > 0
                    ? colors.map((e) => e?.colorName)
                    : []
                }
                placeholder="Select Color"
                width={"100%"}
                onChange={(e) => setChoosenColor(e)}
              />}
              {/* <TextField
                value={color}
                onChange={(e) => setColor(e?.target.value)}
                size="small"
                placeholder="Enter Product Color"
                sx={{
                  width: "100%",
                  fontSize: "10px",
                  padding: 0,
                  marginTop: 0.5,
                  fontFamily: "Poppins",
                  fontWeight: "bold",
                }}
              /> */}
              {/* <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "column", // Default direction for xs screen size
                  flexWrap: "wrap",
                  border: `1px solid ${Colors.border}`,
                  padding: 10,
                  backgroundColor: showColorPicker ? color : Colors.white,
                }}
              > */}
              {/* {!color && (
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "400",
                      fontFamily: "Poppins",
                      marginBottom: 10, // Add margin for spacing
                    }}
                  >
                    {!color && "Add Product Color"}
                  </Typography>
                )} */}
              {/* {!showColorPicker && (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center", // Center the items on xs screen size
                    }}
                  >
                    {selectedColor &&
                      selectedColor?.length > 0 &&
                      selectedColor?.map((e, i) => {
                        return (
                          <Box
                            key={i}
                            sx={{
                              width: 25,
                              height: 25,
                              backgroundColor: e?.color,
                              margin: 1, // Add margin for spacing between color boxes
                            }}
                          ></Box>
                        );
                      })}
                  </Box>
                )} */}
              {/* <Box style={{ width: "100%" }}>
                  {showColorPicker && (
                    <HexColorPicker
                      style={{ marginBottom: 10 }}
                      color={color}
                      onChange={handleColorChange}
                    />
                  )}
                  <Button
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%", // Make the button take the full width
                    }}
                    onClick={() =>
                      showColorPicker
                        ? closeColorPicker()
                        : setShowColorPicker(true)
                    }
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: Colors.button,
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        textAlign: "center", // Center the text on xs screen size
                      }}
                    >
                      {!showColorPicker ? "+ Add Color" : "Select Color"}
                    </Typography>
                  </Button>
                </Box> */}
              {/* </Box> */};
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 0,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Bar Code
                </Typography>
              </Box>
              <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Product Bar Code
                  </Typography>
                </Box>
                <TextField
                  value={barcodeData}
                  onChange={(e) =>
                     setBarcodeData(e?.target.value)
                  }
                  size="small"
                  placeholder="Enter Product Bar Code"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />

                <Box
                  style={{
                    padding: "15px 0px 0px 0px",
                    marginTop: 5,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Button
                    onClick={() => generateNewBarcode()}
                    style={{
                      color: "#141414",
                      fontSize: 14,
                      fontWeight: "600",
                      fontFamily: "Poppins",
                      textAlign: "center",
                      width: "100%",
                      border: `1px solid ${Colors.border}`,
                      backgroundColor: Colors.main,
                      padding: 10,
                    }}
                  >
                    Auto Generate Bar Code
                  </Button>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 10,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Product Sku
                </Typography>
              </Box>
              <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Product Sku
                  </Typography>
                </Box>
                <TextField
                  value={skuData}
                  onChange={(e) => !routeData && setSkuData(e?.target.value)}
                  size="small"
                  placeholder="Enter Product Bar Code"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />

                <Box
                  style={{
                    padding: "15px 0px 0px 0px",
                    marginTop: 5,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Button
                    onClick={() => !routeData && generateNewSku()}
                    style={{
                      color: "#141414",
                      fontSize: 14,
                      fontWeight: "600",
                      fontFamily: "Poppins",
                      textAlign: "center",
                      width: "100%",
                      border: `1px solid ${Colors.border}`,
                      backgroundColor: Colors.main,
                      padding: 10,
                    }}
                  >
                    Auto Generate Sku
                  </Button>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  p: 0,
                  alignItems: "center",
                  marginTop: 10,
                  marginBottom: 20,
                }}
              >
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 18,

                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Supplier
                  </Typography>

                  <CustomButton
                    onClick={() => setAddNewSupplier(!addNewSupplier)}
                    text={
                      addNewSupplier
                        ? "Close Supplier Form"
                        : "Add New Supplier"
                    }
                    style={{ p: 1, fontSize: "12px", fontWeight: "400" }}
                  />
                </Box>

                {addNewSupplier && (
                  <Grid
                    container
                    xs={12}
                    md={12}
                    xl={12}
                    lg={12}
                    sm={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "10px",
                    }}
                  >
                    <Grid xs={12} md={5.5}>
                      <Typography
                        style={{
                          color: Colors.text,
                          fontSize: 14,
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          textAlign: "left",
                        }}
                      >
                        Supplier Name:
                      </Typography>
                      <Box
                        sx={{
                          border: `1px solid ${Colors.border}`,
                          padding: "5px 5px 5px 5px",
                          borderRadius: "5px",
                          fontSize: "10px",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 0.5,
                        }}
                      >
                        <TextField
                          variant="standard" // <== changed this
                          margin="normal"
                          required
                          type="text"
                          onChange={(e) =>
                            setSupplierDetails({
                              ...supplierDetails,
                              supplierName: e.target.value,
                            })
                          }
                          fullWidth
                          sx={{
                            width: "100%",
                            fontSize: "10px",
                            padding: 0,
                            margin: 0,
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            marginLeft: "10px",
                          }}
                          placeholder="Enter Supplier Name..."
                          InputProps={{
                            // startAdornment: <AccountCircle />, // <== adjusted this
                            disableUnderline: true, // <== added this
                            // fontSize: "2px"
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid xs={12} md={5.5}>
                      <Typography
                        style={{
                          color: Colors.text,
                          fontSize: 14,
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          textAlign: "left",
                        }}
                      >
                        Shop Detail:
                      </Typography>
                      <Box
                        sx={{
                          border: `1px solid ${Colors.border}`,
                          padding: "5px 5px 5px 5px",
                          borderRadius: "5px",
                          fontSize: "10px",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 0.5,
                        }}
                      >
                        <TextField
                          variant="standard" // <== changed this
                          margin="normal"
                          required
                          type="text"
                          onChange={(e) =>
                            setSupplierDetails({
                              ...supplierDetails,
                              shopDetails: e.target.value,
                            })
                          }
                          fullWidth
                          sx={{
                            width: "100%",
                            fontSize: "10px",
                            padding: 0,
                            margin: 0,
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            marginLeft: "10px",
                          }}
                          placeholder="Enter Shop Details..."
                          InputProps={{
                            // startAdornment: <AccountCircle />, // <== adjusted this
                            disableUnderline: true, // <== added this
                            // fontSize: "2px"
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid xs={12} md={5.5}>
                      <Typography
                        style={{
                          color: Colors.text,
                          fontSize: 14,
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          textAlign: "left",
                        }}
                      >
                        Mobile Number:
                      </Typography>
                      <Box
                        sx={{
                          border: `1px solid ${Colors.border}`,
                          padding: "5px 5px 5px 5px",
                          borderRadius: "5px",
                          fontSize: "10px",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 0.5,
                        }}
                      >
                        <TextField
                          variant="standard" // <== changed this
                          margin="normal"
                          required
                          type="number"
                          onChange={(e) =>
                            setSupplierDetails({
                              ...supplierDetails,
                              mobileNumber: e.target.value,
                            })
                          }
                          fullWidth
                          sx={{
                            width: "100%",
                            fontSize: "10px",
                            padding: 0,
                            margin: 0,
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            marginLeft: "10px",
                          }}
                          placeholder="Enter Mobile Number..."
                          InputProps={{
                            // startAdornment: <AccountCircle />, // <== adjusted this
                            disableUnderline: true, // <== added this
                            // fontSize: "2px"
                          }}
                        />
                      </Box>
                    </Grid>

                    <Box
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 10,
                      }}
                    >
                      <CustomButton
                        onClick={() => handleAddSupplier()}
                        text={
                          loading ? (
                            <RingLoader loading={loading} size={30} />
                          ) : (
                            "Save"
                          )
                        }
                        style={{ p: 1, fontSize: "12px", fontWeight: "400" }}
                      />
                    </Box>
                  </Grid>
                )}

                <BasicSelect
                  style={{ marginTop: 1 }}
                  value={
                    selectedSupplier?.supplierName
                      ? selectedSupplier?.supplierName
                      : "select"
                  }
                  status="Select Supplier"
                  id={supplierName}
                  width={"100%"}
                  onChange={(e) => selectSupplier(e)}
                />
              </Box>
              {/* <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 10,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Print
                </Typography>
              </Box> */}
              {/* <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    color: Colors.text,
                    fontSize: 14,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Main Text
                </Typography>
                <TextField
                  value={productData.printProductName}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      printProductName: e.target.value,
                    }))
                  }
                  size="small"
                  placeholder="Type Product Name"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />

                <Box
                  style={{
                    padding: "15px 0px 0px 0px",
                    marginTop: 5,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Description
                  </Typography>
                  <Box
                    style={{
                      width: "100%",
                      padding: "0px 0px 0px 0px",
                      borderBottom: 0,
                      marginTop: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        border: `1px solid ${Colors.border}`,
                        justifyContent: { xs: "space-between" },
                        borderBottom: "0px",
                        padding: 1,
                        flexWrap: "wrap",
                        marginTop: 0.5,
                        borderTopRightRadius: "5px",
                        borderTopLeftRadius: "5px",
                      }}
                    >
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            bold: !editorState?.bold,
                          })
                        }
                        style={{
                          backgroundColor: editorState?.bold
                            ? Colors.buttonLight
                            : Colors.white,
                          border: "0px",
                          borderRadius: 5,
                        }}
                      >
                        <img src={require("../../../Images/bold.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            italic: !editorState?.italic,
                          })
                        }
                        style={{
                          backgroundColor: editorState?.italic
                            ? Colors.buttonLight
                            : Colors.white,
                          border: "0px",
                          borderRadius: 5,
                        }}
                      >
                        <img src={require("../../../Images/italic.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            underline: !editorState?.underline,
                          })
                        }
                        style={{
                          backgroundColor: editorState?.underline
                            ? Colors.buttonLight
                            : Colors.white,
                          border: "0px",
                        }}
                      >
                        <img src={require("../../../Images/underline.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            alignment: "left",
                          })
                        }
                        style={{
                          backgroundColor:
                            editorState?.alignment == "left"
                              ? Colors.buttonLight
                              : Colors.white,
                          border: "0px",
                          borderRadius: 5,
                        }}
                      >
                        <img src={require("../../../Images/left.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            alignment: "center",
                          })
                        }
                        style={{
                          backgroundColor:
                            editorState?.alignment == "center"
                              ? Colors.buttonLight
                              : Colors.white,
                          border: "0px",
                        }}
                      >
                        <img src={require("../../../Images/center.png")} />
                      </button>
                      <button
                        onClick={() =>
                          setEditorState({
                            ...editorState,
                            alignment: "right",
                          })
                        }
                        style={{
                          backgroundColor:
                            editorState?.alignment == "right"
                              ? Colors.buttonLight
                              : Colors.white,
                          border: "0px",
                        }}
                      >
                        <img src={require("../../../Images/right.png")} />
                      </button>
                    </Box>
                    <Box>
                      <textarea
                        value={productData.printProductDescription}
                        onChange={(e) =>
                          setProductData((prev) => ({
                            ...prev,
                            printProductDescription: e.target.value,
                          }))
                        }
                        size="small"
                        multiline={true}
                        row={10}
                        placeholder="Type Description..."
                        style={{
                          width: "100%",
                          fontSize: 14,
                          padding: "3px 10px 3px 10px",
                          marginTop: 1,
                          fontFamily: "Poppins",
                          border: `1px solid ${Colors.border}`,
                          height: 100,
                          fontWeight: editorState?.bold ? "bold" : "normal",
                          fontStyle: editorState?.italic ? "italic" : "normal",
                          textDecoration: editorState?.underline
                            ? "underline"
                            : "none",
                          textAlign: editorState?.alignment,
                          borderBottomLeftRadius: "5px",
                          borderBottomRightRadius: "5px",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Box style={{ padding: 10 }}>
              {/* Content for the second column */}

              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: 10,
                  paddingTop: 10,
                }}
              >
                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="images")?.is &&<Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Product Images
                </Typography>}

                <Button
                  onClick={downloadTemplate}
                  style={{
                    borderRadius: 20,
                    backgroundColor: Colors.button,
                    color: Colors.white,
                    fontSize: 12,
                    padding: 10,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                >
                  Download Excel Template
                </Button>
              </Box>
             {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="images")?.is && <Box
                sx={{
                  padding: "10px",
                  border: `1px solid ${Colors.border}`,
                  borderRadius: 5,
                  display: "flex",
                  flexDirection: {
                    xs: "column",
                    sm: "column",
                    md: "column",
                    lg: "row",
                  },

                  justifyContent: { lg: "space-around", xs: "space-between" },
                  width: "100%",
                }}
              >
                <Grid md={12} lg={4} sm={12}>
                  <Box
                    {...getRootProps()}
                    style={{
                      padding: 10,
                      height: 110,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: 5,
                      paddingRight: 20,
                      paddingLeft: 20,
                    }}
                  >
                    <Box
                      sx={{
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100px",
                        backgroundColor: Colors.buttonLight,
                        borderRadius: "5px",
                        flexDirection: "column",
                        padding: "10px",
                      }}
                    >
                      <input
                        style={{
                          border: "2px solid red",
                          width: "100%",
                          height: "100%",
                          // padding: 100,
                        }}
                        {...getInputProps()}
                      />

                      <img
                        src={require("../../../Images/picker.png")}
                        style={{ height: 50 }}
                      />

                      {isDragActive ? (
                        <Typography>Drop the files here ...</Typography>
                      ) : (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: {
                                xs: 8,
                                sm: 10,
                                md: "10px",
                                fontFamily: "Poppins",
                                fontWeight: "600",
                              },
                              color: Colors.button,
                              textDecoration: "underline",
                            }}
                          >
                            Click to upload{" "}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "8px",
                                sm: "8px",
                                md: "10px",
                                fontFamily: "Poppins",
                                fontWeight: "600",
                              },
                              color: Colors.text,
                              textDecoration: "none",
                            }}
                          >
                            or drag and drop
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    {/* <input
                                        type="file"
                                        id="avatar"
                                        accept="image/*"
                                        style={{
                                            display: "none",
                                            border: "2px solid red",
                                            padding: 10,
                                        }} */}
                    {/* // onChange={handleImageChange} */}
                    {/* /> */}
                  </Box>
                </Grid>

                <Grid lg={4} md={12} sm={12}>
                  <Box
                    onDoubleClick={() =>
                      setDeleteImage({ ...deleteImage, image: true })
                    }
                    style={{
                      padding: 10,
                      height: 100,
                      width: 150,

                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      backgroundColor: Colors.white,
                      borderRadius: 5,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor:
                          deleteImage?.image && image
                            ? Colors.buttonLight
                            : Colors.white,
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        height: "100px",
                        width: "100%",
                        justifyContent: "center",
                        borderRadius: "5px",
                      }}
                    >
                      {!image && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "16px",
                              fontFamily: "Poppins",
                              fontWeight: "600",
                            },
                            color: Colors.text,
                            textDecoration: "none",
                          }}
                        >
                          Image 1
                        </Typography>
                      )}
                      {image && !deleteImage?.image && (
                        <img
                          src={`${Image_Uri}products/${image}`}
                          style={{
                            maxHeight: "80%",
                            maxWidth: "80%",
                            backgroundColor:
                              deleteImage?.image && image
                                ? Colors.buttonLight
                                : Colors.white,
                          }}
                          alt="Uploaded"
                          className="preview-image"
                        />
                      )}

                      {image && deleteImage?.image && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => handleDeleteImage(0)}
                            sx={{
                              backgroundColor: Colors.red,
                              color: Colors.white,
                              width: "50px",
                              fontSize: "10px",
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            onClick={() =>
                              setDeleteImage({ ...deleteImage, image: false })
                            }
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              width: "50px",
                              fontSize: "10px",
                              mt: 1,
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      )}

                      {/* {image && <Box sx={{display:"flex",height:"100%",marginTop:"5x"}} > <CloseIcon fontSize="medium" color={Colors.button} /> </Box>} */}
                    </Box>
                  </Box>
                </Grid>
                <Grid lg={4} md={12} sm={12}>
                  <Box
                    onDoubleClick={() =>
                      setDeleteImage({ ...deleteImage, image1: true })
                    }
                    style={{
                      padding: 10,
                      height: 100,
                      width: 150,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      backgroundColor: Colors.white,
                      borderRadius: 5,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor:
                          deleteImage?.image1 && image1
                            ? Colors.buttonLight
                            : Colors.white,
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        height: "100px",
                        justifyContent: "center",
                        borderRadius: "5px",
                        zindex: 10,
                      }}
                    >
                      {!image1 && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "16px",
                              fontFamily: "Poppins",
                              fontWeight: "600",
                            },
                            color: Colors.text,
                            textDecoration: "none",
                          }}
                        >
                          Image 2
                        </Typography>
                      )}
                      {image1 && !deleteImage?.image1 && (
                        <img
                          src={`${Image_Uri}products/${image1}`}
                          style={{
                            maxHeight: "80%",
                            maxWidth: "80%",
                            backgroundColor:
                              deleteImage?.image1 && image1
                                ? Colors.buttonLight
                                : Colors.white,
                          }}
                          alt="Uploaded"
                          className="preview-image"
                        />
                      )}

                      {image1 && deleteImage?.image1 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => handleDeleteImage(1)}
                            sx={{
                              backgroundColor: Colors.red,
                              color: Colors.white,
                              width: "50px",
                              fontSize: "10px",
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            onClick={() =>
                              setDeleteImage({ ...deleteImage, image1: false })
                            }
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              width: "50px",
                              fontSize: "10px",
                              mt: 1,
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      )}

                      {/* {image && <Box sx={{display:"flex",height:"100%",marginTop:"5x"}} > <CloseIcon fontSize="medium" color={Colors.button} /> </Box>} */}
                    </Box>
                  </Box>
                </Grid>

                <Grid lg={4} md={12} sm={12}>
                  <Box
                    onDoubleClick={() =>
                      setDeleteImage({ ...deleteImage, image2: true })
                    }
                    style={{
                      padding: 10,
                      // paddingRight:0,
                      // paddingLeft:0,
                      height: 100,
                      width: 150,
                      // margin: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      backgroundColor: Colors.white,
                      borderRadius: 5,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor:
                          deleteImage?.image2 && image2
                            ? Colors.buttonLight
                            : Colors.white,
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        height: 100,
                        justifyContent: "center",
                        borderRadius: "5px",
                        zindex: 10,
                      }}
                    >
                      {!image2 && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "16px",
                              fontFamily: "Poppins",
                              fontWeight: "600",
                            },
                            color: Colors.text,
                            textDecoration: "none",
                          }}
                        >
                          Image 3
                        </Typography>
                      )}
                      {image2 && !deleteImage?.image2 && (
                        <img
                          src={`${Image_Uri}products/${image2}`}
                          style={{
                            maxHeight: "80%",
                            maxWidth: "80%",
                            backgroundColor:
                              deleteImage?.image2 && image2
                                ? Colors.buttonLight
                                : Colors.white,
                          }}
                          alt="Uploaded"
                          className="preview-image"
                        />
                      )}

                      {image2 && deleteImage?.image2 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => handleDeleteImage(2)}
                            sx={{
                              backgroundColor: Colors.red,
                              color: Colors.white,
                              width: "50px",
                              fontSize: "10px",
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            onClick={() =>
                              setDeleteImage({ ...deleteImage, image2: false })
                            }
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              width: "50px",
                              fontSize: "10px",
                              mt: 1,
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      )}

                      {/* {image && <Box sx={{display:"flex",height:"100%",marginTop:"5x"}} > <CloseIcon fontSize="medium" color={Colors.button} /> </Box>} */}
                    </Box>
                  </Box>
                </Grid>

                {/* <Grid lg={3.8} md={12} sm={12}>
                  <Box
                    onDoubleClick={() =>
                      setDeleteImage({ ...deleteImage, image2: true })
                    }
                    style={{
                      padding: 10,
                      height: "100px",
                      width: "100px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      backgroundColor: Colors.white,
                      borderRadius: 5,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor:
                          deleteImage?.image && image
                            ? Colors.buttonLight
                            : Colors.white,
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        height: "100px",
                        justifyContent: "center",
                        borderRadius: "5px",
                        zindex: 10,
                      }}
                    >
                      {!image2 && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "16px",
                              fontFamily: "Poppins",
                              fontWeight: "600",
                            },
                            color: Colors.text,
                            textDecoration: "none",
                          }}
                        >
                          Image 3
                        </Typography>
                      )}
                      {image2 && !deleteImage?.image2 && (
                        <img
                          src={`${Image_Uri}products/${image2}`}
                          style={{
                            height: "80%",
                            width: "80%",
                            backgroundColor:
                              deleteImage?.image2 && image2
                                ? Colors.buttonLight
                                : Colors.white,
                          }}
                          alt="Uploaded"
                          className="preview-image"
                        />
                      )}

                      {image2 && deleteImage?.image2 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => handleDeleteImage(2)}
                            sx={{
                              backgroundColor: Colors.red,
                              color: Colors.white,
                              width: "50px",
                              fontSize:"10px",
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            onClick={() =>
                              setDeleteImage({ ...deleteImage, image2: false })
                            }
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              width: "50px",
                              fontSize:"10px",
                              mt: 1,
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      )}

                      {/* {image && <Box sx={{display:"flex",height:"100%",marginTop:"5x"}} > <CloseIcon fontSize="medium" color={Colors.button} /> </Box>} */}
                {/* </Box>
                  </Box>
                </Grid>  */}

                {/* <Grid md={12} lg={4} sm={12}>
                  <Box
                    style={{
                      padding: 10,
                      height: "100px",
                      width: "100px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      backgroundColor: Colors.white,
                      borderRadius: 5,
                      // paddingRight: 20,
                      // paddingLeft: 20,
                    }}
                  >
                    <Box
                      onDoubleClick={() =>
                        setDeleteImage({ ...deleteImage, image1: true })
                      }
                      sx={{
                        backgroundColor:
                          deleteImage?.image1 && image1
                            ? Colors.buttonLight
                            : Colors.white,
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        height: 100,
                        justifyContent: "center",
                        borderRadius: "5px",
                      }}
                    >
                      {!image1 && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "16px",
                              fontFamily: "Poppins",
                              fontWeight: "600",
                              height:"100px"
                            },
                            color: Colors.text,
                            textDecoration: "none",
                          }}
                        >
                          Image 2
                        </Typography>
                      )}
                      {image1 && !deleteImage?.image1 && (
                        <img
                          src={`${Image_Uri}products/${image1}`}
                          style={{ height: "90%" }}
                          alt="Uploaded"
                          className="preview-image"
                        />
                      )}

                      {image1 && deleteImage?.image1 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => handleDeleteImage(1)}
                            sx={{
                              backgroundColor: Colors.red,
                              color: Colors.white,
                              width: "100px",
                              fontSize: "12px",
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            onClick={() =>
                              setDeleteImage({ ...deleteImage, image1: false })
                            }
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              width: "120px",
                              mt: 0.5,
                              width: "100px",
                              fontSize: "12px",
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      )}
                    </Box>
                    <Box
                      onDoubleClick={() =>
                        setDeleteImage({ ...deleteImage, image2: true })
                      }
                      sx={{
                        backgroundColor:
                          deleteImage?.image2 && image2
                            ? Colors.buttonLight
                            : Colors.white,
                        border: `2px dotted ${Colors.button}`,
                        display: "flex",
                        alignItems: "center",
                        padding: 2,
                        justifyContent: "center",
                        height: "85px",
                        borderRadius: "5px",
                      }}
                    >
                      {!image2 && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "16px",
                              fontFamily: "Poppins",
                              fontWeight: "600",
                            },
                            color: Colors.text,
                            textDecoration: "none",
                          }}
                        >
                          Product Image 03
                        </Typography>
                      )}
                      {image2 && !deleteImage?.image2 && (
                        <img
                          src={`${Image_Uri}products/${image2}`}
                          style={{ height: "90%" }}
                          alt="Uploaded"
                          className="preview-image"
                        />
                      )}

                      {image2 && deleteImage?.image2 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => handleDeleteImage(2)}
                            sx={{
                              backgroundColor: Colors.red,
                              color: Colors.white,
                              width: "100px",
                              fontSize: "12px",
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            onClick={() =>
                              setDeleteImage({ ...deleteImage, image2: false })
                            }
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              width: "120px",
                              mt: 0.5,
                              width: "100px",
                              fontSize: "12px",
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid> */}
              </Box>}

              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 15,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Inventory Details
                </Typography>
              </Box>

              <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
               {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="make")?.is &&<Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 15,
                    width: "100%",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Make
                  </Typography>

                  <CustomButton
                    onClick={() => setOpenMakeModalVisible(true)}
                    text="Add Make"
                    style={{
                      width: "fit-content",
                      padding: 1,
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  />
                </Box>}
                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="make")?.is &&<BasicSelect
                  style={{ marginTop: 0.5 }}
                  value={selectedMake}
                  status="Select Make"
                  id={make && make.length > 0 ? make.map((e) => e?.make) : []}
                  width={"100%"}
                  onChange={(e) => setSelectedMake(e)}
                  antd={true}
                />}

               {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="make")?.is && <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Model
                  </Typography>

                  <CustomButton
                    onClick={() => setOpenModelModalVisible(true)}
                    text="Add Model"
                    style={{
                      width: "fit-content",
                      padding: 1,
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  />
                </Box>}

                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="make")?.is &&<BasicSelect
                  style={{ marginTop: 0.5 }}
                  value={selectedModel}
                  status="Select Model"
                  id={model && model.length > 0 ? model : []}
                  width={"100%"}
                  onChange={(e) => setSelectedModel(e)}
                  isSearch={true}
                  antd={true}
                />}

                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="compatibility")?.is &&<Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Compatibility
                  </Typography>
                </Box>}

                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="compatibility")?.is &&<TextField
                  value={productData.compatibility}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      compatibility: e.target.value,
                    }))
                  }
                  size="small"
                  placeholder="Enter Compatibility"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />}
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Expiry
                  </Typography>
                </Box>

                <DatePickers
                    style={{
                      // borderRadius: 10,
                      marginTop: { xs: "5px", sm: "0px" },
                    }}
                    values={productData.expiry}
                    onChange={(e) =>
                      setProductData((prev) => ({
                        ...prev,
                        expiry: e,
                      }))
                    }
                  />

                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="IMEI")?.is &&<Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    IMEI
                  </Typography>
                </Box>}

                {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="IMEI")?.is &&<TextField
                  value={productData.IMEI}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      IMEI: e.target.value,
                    }))
                  }
                  size="small"
                  placeholder="Enter IMEI"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />}
 <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Select Type
                  </Typography>
                </Box>
                
                <BasicSelect
                  style={{ marginTop: 0.5 }}
                  value={selectedTypeQun}
                  status="Select Type"
                  id={["one-to-one","kg","boxes","liter","unit-boxes"]}
                    
                  width={"100%"}
                  onChange={(e) => {
                    setSelectedTypeQun(e)
                    console.log(e)
                  }}
                />
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Quantity ({selectedTypeQun}) 
                  </Typography>
                </Box>
                <TextField
                  value={productData.qty}
                  onChange={(e) =>
                    setProductData((prev) => ({ ...prev, qty: e.target.value }))
                  }
                  size="small"
                  placeholder="Add Product Quantity"
                  type="number"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />
                {(selectedTypeQun=="boxes"||selectedTypeQun=="unit-boxes")&&
                <>
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                   Qty Per Boxes
                  </Typography>
                </Box>
                <TextField
                  value={productData.boxes}
                  onChange={(e) =>
                    setProductData((prev) => ({ ...prev, boxes: e.target.value }))
                  }
                  size="small"
                  placeholder="Enter Boxes Qun"
                  type="number"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />
                </>}
                

                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      color: Colors.text,
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    Remind
                  </Typography>
                </Box>
                <TextField
                  value={productData.remind}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      remind: e.target.value,
                    }))
                  }
                  size="small"
                  type="number"
                  placeholder="Remind me when left"
                  sx={{
                    width: "100%",
                    fontSize: "10px",
                    padding: 0,
                    marginTop: 0.5,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                />
              </Box>

              {/* <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 15,
                }}
              >
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Max Discount
                </Typography>
              </Box> */}

              {/* <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                {discountCategory &&
                  discountCategory?.length > 0 &&
                  discountCategory?.map((e, i) => {
                    return (
                      <Box sx={{ width: "100%", marginTop: 2 }}>
                        <Grid
                          container
                          sm={12}
                          md={12}
                          xl={12}
                          xs={12}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Grid item xs={12} sm={3} md={4} lg={3} xl={2}>
                            <Typography
                              sx={{
                                color: Colors.text,
                                fontSize: {
                                  xs: "10px",
                                  sm: "12px",
                                  md: "14px",
                                },
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                textAlign: "left",
                              }}
                            >
                              {e?.name}
                            </Typography>
                          </Grid>

                          <Grid item xs={9} sm={7} md={6} lg={7} xl={9}>
                            <TextField
                              value={e?.discount}
                              onChange={(event) =>
                                handleDiscount(event.target.value, i)
                              }
                              type="number"
                              variant="standard"
                              placeholder={`Enter Discount For ${e?.category} Category`}
                              size="small"
                              sx={{
                                width: "100%",
                                fontSize: "10px",
                                padding: 0,
                                marginTop: 0.5,
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                              }}
                            />
                          </Grid>
                          <Grid item xs={3} sm={2} md={2} lg={2} xl={1}>
                            <DeleteIcon
                              onClick={() => deleteCategory(i)}
                              fontSize={"large"}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    );
                  })}

                <Box
                  style={{
                    padding: "15px 0px 0px 0px",
                    marginTop: 5,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Button
                    onClick={addCategory}
                    style={{
                      color: "#141414",
                      fontSize: 14,
                      fontWeight: "600",
                      fontFamily: "Poppins",
                      textAlign: "center",
                      width: "100%",
                      border: `1px solid ${Colors.border}`,
                      backgroundColor: Colors.main,
                      padding: 10,
                    }}
                  >
                    Another Discount Category
                  </Button>
                </Box>
              </Box> */}

              {/* <Box style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: 15 }} >

                                <Typography style={{ fontSize: 20, fontWeight: "bold", fontFamily: "Poppins" }} >
                                    Credit Limitation
                                </Typography>

                                <input type="number" style={{ width: 120, textAlign: "right", border: `1px solid ${Colors.border}`, borderRadius: 5, color: creditLimit ? Colors.black : Colors.border, padding: 12, fontSize: 14 }} placeholder='$0.00' onChange={(e) => setCreditLimit(e.target.value)} />

                            </Box> */}

              {/* <Button onClick={() => setListOnOtherPlatform(true)} style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", borderRadius: 5, border: `2px dotted ${Colors.button}`, padding: 10, marginTop: 15, backgroundColor: Colors.buttonLight }} >

                                <Typography sx={{ fontSize: { sm: "14px", md: "18px" }, color: Colors.button, fontFamily: "Poppins", fontWeight: "600" }} >
                                    List On Other Platform
                                </Typography>

                            </Button> */}

              {/* {listOnOtherPlatform && <Box style={{ border: `1px solid ${Colors.border}`, padding: 15, marginTop: 10, borderRadius: 5, display: "flex", alignItems: "flex-start", flexDirection: "column" }} > */}

              {/* {warehouses && warehouses?.length > 0 && warehouses?.map((e, i) => {
                                    return (

                                        <Box sx={{ width: "100%", marginTop: 2 }} >
                                            <Grid container sm={12} md={12} xl={12} xs={12} sx={{ display: "flex", alignItems: "center" }} >
                                                <Grid item xs={12} sm={3} md={4} lg={3} xl={2} >
                                                    <Typography sx={{ color: Colors.text, fontSize: { xs: "10px", sm: "12px", md: "14px" }, fontWeight: "bold", fontFamily: "Poppins", textAlign: "left" }} >
                                                        {e?.name}
                                                    </Typography>
                                                </Grid>


                                                <Grid item xs={9} sm={7} md={6} lg={7} xl={9} >
                                                    <TextField
                                                        // value={data.cityName}
                                                        // onChange={(e) =>
                                                        //   setData((prev) => ({ ...prev, cityName: e.target.value }))
                                                        // }

                                                        // variant="standard"
                                                        size="small"
                                                        sx={{ width: "100%", fontSize: "10px", padding: 0, marginTop: 0.5, fontFamily: "Poppins", fontWeight: "bold" }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3} sm={2} md={2} lg={2} xl={1} >
                                                    <DeleteIcon onClick={() => deleteWarehouse(i)} fontSize={"large"} />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    )
                                })} */}

              {/* </Box>} */}

              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 5,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "18px",
                      md: "20px",
                      lg: "22px",
                      xl: "24px",
                    },
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                  }}
                >
                  Price
                </Typography>
              </Box>

              <Box
                style={{
                  border: `1px solid ${Colors.border}`,
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                }}
              >
                <Grid
                  container
                  xs={12}
                  md={12}
                  xl={12}
                  lg={12}
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid xs={12} md={5.5}>
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                        textAlign: "left",
                      }}
                    >
                      Cost (X VAT)
                    </Typography>
                    <Box
                      sx={{
                        border: `1px solid ${Colors.border}`,
                        padding: "5px 5px 5px 5px",
                        borderRadius: "5px",
                        fontSize: "10px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "5px",
                          backgroundColor: Colors.border,
                          fontSize: "16px",
                          color: "#141414",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                         {vatRate?.currency}
                      </Box>
                      <TextField
                        value={productData?.cost_price}
                        onChange={(e) => {
                          setProductData({
                            ...productData,
                            cost_price: e?.target?.value,
                          });
                        }}
                        variant="standard" // <== changed this
                        margin="normal"
                        required
                        fullWidth
                        sx={{
                          width: "100%",
                          fontSize: "10px",
                          padding: 0,
                          margin: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          marginLeft: "10px",
                        }}
                        placeholder="00.00"
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true, // <== added this
                          // fontSize: "2px"
                        }}
                      />
                    </Box>
                  </Grid>

                 {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="diamond")?.is && <Grid xs={12} md={5.5}>
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                        textAlign: "left",
                      }}
                    >
                      Diamond (X VAT)
                    </Typography>
                    <Box
                      sx={{
                        border: `1px solid ${Colors.border}`,
                        padding: "5px 5px 5px 5px",
                        borderRadius: "5px",
                        fontSize: "10px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "5px",
                          backgroundColor: Colors.border,
                          fontSize: "16px",
                          color: "#141414",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                         {vatRate?.currency}
                      </Box>
                      <TextField
                        value={
                          productData?.diamond
                            ? productData?.diamond
                            : routeData?.diamond
                            ? routeData?.diamond
                            : ""
                        }
                        onChange={(e) => {
                          setProductData({
                            ...productData,
                            diamond: e?.target?.value,
                          });
                        }}
                        variant="standard" // <== changed this
                        margin="normal"
                        required
                        fullWidth
                        sx={{
                          width: "100%",
                          fontSize: "10px",
                          padding: 0,
                          margin: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          marginLeft: "10px",
                        }}
                        placeholder="00.00"
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true, // <== added this
                          // fontSize: "2px"
                        }}
                      />
                    </Box>
                  </Grid>}
                 {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="platinum")?.is && <Grid xs={12} md={5.5}>
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                        textAlign: "left",
                      }}
                    >
                      Platinum (X VAT)
                    </Typography>
                    <Box
                      sx={{
                        border: `1px solid ${Colors.border}`,
                        padding: "5px 5px 5px 5px",
                        borderRadius: "5px",
                        fontSize: "10px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "5px",
                          backgroundColor: Colors.border,
                          fontSize: "16px",
                          color: "#141414",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                         {vatRate?.currency}
                      </Box>
                      <TextField
                        value={
                          productData?.trade_price
                            ? productData?.trade_price
                            : routeData?.trade_price
                            ? routeData?.trade_price
                            : ""
                        }
                        onChange={(e) => {
                          setProductData({
                            ...productData,
                            trade_price: e?.target?.value,
                          });
                        }}
                        variant="standard" // <== changed this
                        margin="normal"
                        required
                        fullWidth
                        sx={{
                          width: "100%",
                          fontSize: "10px",
                          padding: 0,
                          margin: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          marginLeft: "10px",
                        }}
                        placeholder="00.00"
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true, // <== added this
                          // fontSize: "2px"
                        }}
                      />
                    </Box>
                  </Grid>}
                 {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="gold")?.is && <Grid xs={12} md={5.5}>
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                        textAlign: "left",
                      }}
                    >
                      Gold (X VAT)
                    </Typography>
                    <Box
                      sx={{
                        border: `1px solid ${Colors.border}`,
                        padding: "5px 5px 5px 5px",
                        borderRadius: "5px",
                        fontSize: "10px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "5px",
                          backgroundColor: Colors.border,
                          fontSize: "16px",
                          color: "#141414",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                         {vatRate?.currency}
                      </Box>
                      <TextField
                        value={
                          productData?.warehouse_price
                            ? productData?.warehouse_price
                            : routeData?.warehouse_price
                            ? routeData?.warehouse_price
                            : ""
                        }
                        onChange={(e) => {
                          setProductData({
                            ...productData,
                            warehouse_price: e?.target?.value,
                          });
                        }}
                        variant="standard" // <== changed this
                        margin="normal"
                        required
                        fullWidth
                        sx={{
                          width: "100%",
                          fontSize: "10px",
                          padding: 0,
                          margin: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          marginLeft: "10px",
                        }}
                        placeholder="00.00"
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true, // <== added this
                          // fontSize: "2px"
                        }}
                      />
                    </Box>
                  </Grid>}
                  <Grid xs={12} md={5.5}>
                    <Typography
                      style={{
                        color: Colors.text,
                        fontSize: 14,
                        fontWeight: "bold",
                        fontFamily: "Poppins",
                        textAlign: "left",
                      }}
                    >
                      Retail (W VAT)
                    </Typography>
                    <Box
                      sx={{
                        border: `1px solid ${Colors.border}`,
                        padding: "5px 5px 5px 5px",
                        borderRadius: "5px",
                        fontSize: "10px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "5px",
                          backgroundColor: Colors.border,
                          fontSize: "16px",
                          color: "#141414",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                         {vatRate?.currency}
                      </Box>
                      <TextField
                        value={
                          productData?.retail_price
                            ? productData?.retail_price
                            : routeData?.retail_price
                            ? routeData?.retail_price
                            : ""
                        }
                        onChange={(e) => {
                          setProductData({
                            ...productData,
                            retail_price: e?.target?.value,
                          });
                        }}
                        variant="standard" // <== changed this
                        margin="normal"
                        required
                        fullWidth
                        sx={{
                          width: "100%",
                          fontSize: "10px",
                          padding: 0,
                          margin: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          marginLeft: "10px",
                        }}
                        placeholder="00.00"
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true, // <== added this
                          // fontSize: "2px"
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  xs={12}
                  md={12}
                  xl={12}
                  lg={12}
                  sm={12}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 10,
                  }}
                ></Grid>
              </Box>
             {vatRate?.role_access?.find((e)=>e.id=="addnewstock")?.child?.find((e)=>e.id=="wordpress")?.is && <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px !important",
                  marginTop: "10px !important",
                }}
              >
                <div>
                  {routeData?.in_wordpress ? "Update" : "Upload"} On WordPress:
                </div>
                <Switch
                  value={in_wordpress}
                  onChange={(e) => setIn_wordpress(e)}
                />
                <Select
                  defaultValue="wp"
                  onChange={(e) => setSelectPriceStatus(e)}
                  options={[
                    { value: "cp", label: "Cost" },
                    { value: "di", label: "Diamond" },
                    { value: "tp", label: "Platinum" },
                    { value: "wp", label: "Gold" },
                    { value: "rp", label: "Retail" },
                  ]}
                />
              </Box>}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 5,
                  marginBottom: { xs: 2, sm: 2, md: 0 },
                }}
              >
                <Box
                  sx={{
                    width: {
                      xl: "45%",
                      lg: "55%",
                      md: "65%",
                      sm: "55%",
                      xs: "80%",
                    },
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    onClick={handleDiscardClick}
                    sx={{
                      backgroundColor: Colors.white,
                      color: Colors.button,
                      border: `1px solid ${Colors.button}`,
                      borderRadius: 5,
                      padding: "10px 25px 10px 25px",
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      width: "48%",
                    }}
                  >
                    Discard
                  </Button>

                  <Button
                    onClick={() => handleNextClick()}
                    sx={{
                      backgroundColor: Colors.button,
                      color: Colors.white,
                      border: `1px solid ${Colors.button}`,
                      borderRadius: 5,
                      padding: "10px 25px 10px 25px",
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      width: "48%",
                      "&:hover": {
                        color: Colors.button, // Set your desired hover color
                      },
                    }}
                  >
                    {loading ? (
                      <RingLoader
                        loading={loading}
                        size={30}
                        color={Colors.black}
                      />
                    ) : routeData ? (
                      "Save"
                    ) : (
                      "Save"
                    )}
                  </Button>
                </Box>
              </Box>

              {departmentModalVisible && (
                <DepartmentModal
                  open={departmentModalVisible}
                  placeholder={"Enter Department Name..."}
                  loading={departmentLoading}
                  onChange={(e) => setDepartmentName(e.target.value)}
                  closeModal={() => setDepartmentModalVisible(false)}
                  heading={"Add Department"}
                  confirm={() => handleAddDepartment()}
                />
              )}

              {openMakeModalVisible && (
                <MakeModal
                  open={openMakeModalVisible}
                  placeholder={"Enter Make..."}
                  loading={departmentLoading}
                  onChange={(e) => setMakeName(e.target.value)}
                  closeModal={() => setOpenMakeModalVisible(false)}
                  heading={"Add Make"}
                  confirm={() => handleAddMake()}
                />
              )}

              {openModelModalVisible && (
                <MakeModal
                  open={openModelModalVisible}
                  selectedMake={selectedMake}
                  setSelectedMake={setSelectedMake}
                  placeholder={"Enter Model Name..."}
                  loading={categoryLoading}
                  showMake={true}
                  onChange={(e) => setModelName(e.target.value)}
                  closeModal={() => setOpenModelModalVisible(false)}
                  heading={"Add Model"}
                  confirm={() => handleAddModel()}
                />
              )}

              {categoryModalVisible && (
                <DepartmentModal
                  open={categoryModalVisible}
                  selectedDepartment={selectedDepartment}
                  setSelectedDepartment={setSelectedDepartment}
                  placeholder={"Enter Category Name..."}
                  loading={categoryLoading}
                  showDeparment={true}
                  onChange1={(e) =>
                    setCategoryPer({ ...categoryPer, a: e.target.value })
                  }
                  onChange2={(e) =>
                    setCategoryPer({ ...categoryPer, b: e.target.value })
                  }
                  onChange3={(e) =>
                    setCategoryPer({ ...categoryPer, c: e.target.value })
                  }
                  onChange4={(e) =>
                    setCategoryPer({ ...categoryPer, d: e.target.value })
                  }
                  onChange={(e) => setCategoryName(e.target.value)}
                  closeModal={() => setCategoryModalVisible(false)}
                  heading={"Add Category"}
                  confirm={() => handleAddCategory()}
                />
              )}

              {subCategoryModalVisible && (
                <DepartmentModal
                  open={subCategoryModalVisible}
                  selectedDepartment={selectedDepartment}
                  setSelectedDepartment={setSelectedDepartment}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  placeholder={"Enter Subcategory Name..."}
                  loading={subcategoryLoading}
                  showDeparment={true}
                  showCategory={true}
                  onChange={(e) => setSubcategoryName(e.target.value)}
                  closeModal={() => setSubCategoryModalVisible(false)}
                  heading={"Add Category"}
                  confirm={() => handleAddSubCategory()}
                />
              )}

              {discardModal && (
                <CustomModal
                  open={discardModal}
                  closeModal={() => setDiscardModal(false)}
                  heading={"Discard Changes"}
                  confirm={() => handleConfirmClick()}
                  text={"Are your sure you want to discard this changes."}
                />
              )}

              {openColorModal && (
                <CustomModal
                  open={openColorModal}
                  closeModal={() => setOpenColorModal(false)}
                  heading={"Add Color"}
                  credit={true}
                  placeholder={"Enter Color Name"}
                  loading={colorLoading}
                  onChange={(e) => setColorName(e?.target?.value)}
                  confirm={() => handleAddColor()}
                  text={"Are your sure you want to add this changes."}
                />
              )}
              <div>
                <Modal
                  title="Uploaded Data"
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  footer={
                    <Button
                      onClick={() => setReportVisible(true)}
                      type="primary"
                    >
                      Validate File
                    </Button>
                  }
                  width={800}
                >
                  <Table
                    style={{ overflowX: "scroll" }}
                    dataSource={data}
                    columns={columns}
                    pagination={{ pageSize: 10 }}
                    rowClassName={getRowClassName}
                  />
                </Modal>
                {data?.length != 0 && (
                  <Modal
                    title={
                      <Button
                        key="download"
                        onClick={downloadReport}
                        type="primary"
                      >
                        Download Detail Report
                      </Button>
                    }
                    visible={reportVisible}
                    onCancel={() => setReportVisible(false)}
                    footer={[
                      <Button
                        key="close"
                        onClick={() => setReportVisible(false)}
                      >
                        Close
                      </Button>,
                      <Button
                        key="download"
                        onClick={downloadReport}
                        type="primary"
                      >
                        Download Report
                      </Button>,
                    ]}
                    width={600}
                  >
                    <List
                      dataSource={data.filter(
                        (row) =>
                          row.missingFields.length > 0 ||
                          row.isDuplicateSku ||
                          row.isDuplicateBarCode
                      )}
                      renderItem={(item) => {
                        const issues = [];
                        if (item.missingFields.length > 0)
                          issues.push(
                            `Missing fields: ${item.missingFields.join(", ")}`
                          );
                        // if (item.isDuplicateSku) issues.push("Duplicate SKU");
                        // if (item.isDuplicateBarCode) issues.push("Duplicate BarCode");
                        if (item.isFileDuplicateSku)
                          issues.push(
                            `Duplicate SKU in file (Lines: ${item.fileDuplicateLinesSku.join(
                              ", "
                            )})`
                          );
                        if (item.isFileDuplicateBarCode)
                          issues.push(
                            `Duplicate BarCode in file (Lines: ${item.fileDuplicateLinesBarCode.join(
                              ", "
                            )})`
                          );
                        if (item.isDbDuplicateSku)
                          issues.push("Duplicate SKU in database");
                        if (item.isDbDuplicateBarCode)
                          issues.push("Duplicate BarCode in database");
                        if (item.isInvalidSupplier)
                          issues.push("Invalid Supplier Name");
                        if (item.isInvalidCategory)
                          issues.push("Invalid category in database");
                        if (item.isInvalidSubCategory)
                          issues.push("Invalid sub-category in database");
                        return (
                          <List.Item>
                            <div>
                              <strong>Row {item.key + 1}:</strong>{" "}
                              {issues.join("; ")}
                            </div>
                          </List.Item>
                        );
                      }}
                    />
                  </Modal>
                )}
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
